import React from 'react';

import { ChildrenProps, cn } from '../../../../../utils';
import { ClassNameDecorator } from '../../../../decorators';
import { ClassInjector } from '../../../../injectors';

import './PillButton.scoped.scss';

export enum PillLinkColor {
  GREEN = 'pill-button--green',
}

interface Props extends ChildrenProps {
  color: PillLinkColor;
}

const PillButton: ClassNameDecorator<Props> = ({ color, className, children }) => {
  return (
    <ClassInjector classNames={cn('pill-button', `${color}`)} oldClassName={className}>
      {children}
    </ClassInjector>
  );
};

export default PillButton;
